import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Notebook"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 3.75H21C21.8281 3.75083 22.4992 4.42192 22.5 5.25V18.75C22.4988 19.5779 21.8279 20.2488 21 20.25H3C2.17192 20.2492 1.50083 19.5781 1.5 18.75V5.25C1.50083 4.42192 2.17192 3.75083 3 3.75ZM11.25 5.25H3V18.75H11.25V5.25ZM12.75 18.75V5.25H21L21.0015 18.75H12.75ZM19.5 7.5H14.25V9H19.5V7.5ZM14.25 11.25H19.5V12.75H14.25V11.25ZM19.5 15H14.25V16.5H19.5V15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Notebook.vue"]]);
